import { graphql } from 'react-apollo'
import { DELETE_COMMENT } from '../../graphql/mutations'

export default graphql(DELETE_COMMENT, { name: 'deleteComment' })
